{
  "hero.title": "مبدّل بيئات لعدة واجهات سطر أوامر",
  "hero.tagline-1": "ادخل حالة تدفّق هادئة أثناء البرمجة.",
  "hero.tagline-2": "تبديل سلس للبيئات.",
  "hero.subtitle": "إدارة موحّدة لإعدادات Claude Code و Codex و OpenCode، مع تحويل تلقائي عند فشل وسيط الـ API",
  "hero.getDocs": "التوثيق",
  "features.title": "المزايا",
  "features.multiCli.title": "دعم عدة واجهات سطر أوامر",
  "features.multiCli.desc": "يدعم Claude Code و Codex و OpenCode مع إعداد لكل مشروع",
  "features.multiConfig.title": "إدارة الإعدادات",
  "features.multiConfig.desc": "كل إعدادات مزوّدي الـ API في ملف JSON واحد",
  "features.daemon.title": "خدمة موحّدة",
  "features.daemon.desc": "عملية zend واحدة تستضيف الوسيط وواجهة الويب معًا",
  "features.failover.title": "تحويل الوسيط عند الفشل",
  "features.failover.desc": "وسيط HTTP مدمج يتحوّل تلقائيًا حين يتعذّر المزوّد الأساسي",
  "features.routing.title": "توجيه حسب السيناريو",
  "features.routing.desc": "توجيه ذكي وفق خصائص الطلب (التفكير، الصور، وغيرها)",
  "features.binding.title": "ربط المشاريع",
  "features.binding.desc": "اربط المجلدات بملفات تعريف وواجهات محددة لإعداد تلقائي على مستوى المشروع",
  "features.envVars.title": "متغيرات البيئة",
  "features.envVars.desc": "اضبط متغيرات البيئة لكل واجهة على مستوى المزوّد",
  "features.webUi.title": "واجهة الويب",
  "features.webUi.desc": "إدارة مرئية من المتصفح محمية بكلمة مرور",
  "features.webSecurity.title": "أمان واجهة الويب",
  "features.webSecurity.desc": "كلمة مرور تُولَّد تلقائيًا، ومصادقة قائمة على الجلسات، وتشفير RSA لنقل الرموز",
  "features.configSync.title": "مزامنة الإعدادات",
  "features.configSync.desc": "زامن المزوّدين وملفات التعريف والإعدادات بين الأجهزة بتشفير AES-256-GCM",
  "features.comingSoon": "مزايا أخرى في الطريق، ترقّبوا!",
  "install.title": "البدء السريع",
  "install.step1.title": "تثبيت GoZen",
  "install.step1.desc": "سكربت تثبيت من سطر واحد",
  "install.step2.title": "إعداد مزوّد",
  "install.step2.desc": "أضف أول مزوّد API لديك",
  "install.step3.title": "التشغيل",
  "install.step3.desc": "شغّل الواجهة بالإعداد الافتراضي",
  "commands.title": "الأوامر",
  "commands.command": "الأمر",
  "commands.description": "الوصف",
  "commands.items.start": "تشغيل الواجهة (حسب ارتباط المشروع أو الإعداد الافتراضي)",
  "commands.items.profile": "التشغيل بملف تعريف محدد",
  "commands.items.profilePick": "اختيار ملف تعريف تفاعليًا",
  "commands.items.cli": "استخدام واجهة محددة (claude/codex/opencode)",
  "commands.items.yes": "الموافقة تلقائيًا على أذونات الواجهة (claude --permission-mode acceptEdits و codex -a never)",
  "commands.items.use": "استخدام مزوّد محدد مباشرة (دون وسيط)",
  "commands.items.pick": "اختيار مزوّد تفاعليًا للتشغيل",
  "commands.items.list": "عرض كل المزوّدين وملفات التعريف",
  "commands.items.configAddProvider": "إضافة مزوّد جديد",
  "commands.items.configAddProfile": "إضافة ملف تعريف جديد",
  "commands.items.configDefaultClient": "تعيين واجهة سطر الأوامر الافتراضية",
  "commands.items.configDefaultProfile": "تعيين ملف التعريف الافتراضي",
  "commands.items.configResetPassword": "إعادة تعيين كلمة مرور واجهة الويب",
  "commands.items.configSync": "جلب الإعدادات من خدمة المزامنة",
  "commands.items.daemonStart": "تشغيل خدمة zend",
  "commands.items.daemonStop": "إيقاف الخدمة",
  "commands.items.daemonStatus": "عرض حالة الخدمة",
  "commands.items.daemonEnable": "تثبيت الخدمة كخدمة نظام",
  "commands.items.daemonDisable": "إزالة خدمة النظام",
  "commands.items.bind": "ربط المجلد الحالي بملف تعريف",
  "commands.items.bindCli": "ربط المجلد الحالي بواجهة محددة",
  "commands.items.unbind": "فك ارتباط المجلد الحالي",
  "commands.items.status": "عرض حالة ارتباط المجلد الحالي",
  "commands.items.web": "فتح واجهة الويب في المتصفح (تشغّل الخدمة تلقائيًا)",
  "commands.items.upgrade": "الترقية إلى أحدث إصدار",
  "commands.items.version": "عرض الإصدار",
  "commands.items.completion": "توليد الإكمال التلقائي للصدفة (zsh/bash/fish)",
  "homepage.title": "مبدّل بيئات لعدة واجهات سطر أوامر"
}
